import { useTranslation } from 'react-i18next';
import Modal from './Modal';

interface Props {
  title?: string
  details: string | Error | any;
}

function ErrorModal(props: Props) {
  const { t } = useTranslation();

  return (
    <Modal
      title={
        <h3 className="font-gilroy font-semibold text-xl text-red">
          {props.title ?? t("Something went wrong!")}
        </h3>
      }
      className='flex flex-col items-center justify-center gap-4 text-center'
    >
      <div className={`overflow-auto w-full text-left`}>{t("Please contact support if this error continues.")}</div>
    </Modal>
  );
}

export default ErrorModal;
